var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-data-wrapper" },
    [
      _vm.hasData || !_vm.hideWhenNoData ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      !_vm.hasData
        ? _c("div", { staticClass: "no-data-mask" }, [
            _c("div", { staticClass: "no-data-message" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.message || _vm.$t("no_data")) + "\n    "
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }